const Oops = () => {
  return (
    <svg width="633" height="264" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.767 171.75s-.986 24.962 1.115 36.791c.484 2.724 1.599 5.225 3.031 7.461 3.864 6.038 2.352 12.413-4.529 10.4-5.923-1.733-13.512-4.748-23.019-9.871-18.107-11.692 23.402-44.781 23.402-44.781Z"
        fill="var(--art-accent, #1B66D6)"
      />
      <ellipse cx="89.862" cy="138.001" rx="89.862" ry="90.001" fill="var(--art-accent, #1B66D6)" />
      <rect
        x="34.636"
        y="151.126"
        width="17.813"
        height="29.954"
        rx="8.906"
        transform="rotate(-90 34.636 151.126)"
        fill="#fff"
      />
      <rect
        x="73.015"
        y="151.126"
        width="17.813"
        height="29.954"
        rx="8.906"
        transform="rotate(-90 73.015 151.126)"
        fill="#fff"
      />
      <rect
        x="111.393"
        y="151.126"
        width="17.813"
        height="29.954"
        rx="8.906"
        transform="rotate(-90 111.393 151.126)"
        fill="#fff"
      />
      <rect
        x="34.636"
        y="123.522"
        width="19.347"
        height="38.635"
        rx="9.674"
        transform="rotate(-90 34.636 123.522)"
        fill="#fff"
      />
      <rect
        x="34.636"
        y="181.706"
        width="19.347"
        height="38.635"
        rx="9.674"
        transform="rotate(-90 34.636 181.706)"
        fill="#fff"
      />
      <ellipse cx="109.759" cy="114.062" rx="10.732" ry="10.748" fill="#fff" />
      <ellipse cx="86.148" cy="114.063" rx="6.439" ry="6.449" fill="#fff" />
      <ellipse cx="133.363" cy="114.063" rx="6.439" ry="6.449" fill="#fff" />
      <path
        d="M251.719 213.4c-11.148 0-20.876-2.555-29.185-7.664-8.31-5.11-14.761-12.258-19.354-21.444-4.593-9.187-6.89-19.922-6.89-32.205 0-12.334 2.297-23.121 6.89-32.359 4.593-9.238 11.044-16.412 19.354-21.521 8.309-5.11 18.037-7.664 29.185-7.664s20.876 2.554 29.185 7.664c8.31 5.109 14.761 12.283 19.354 21.521 4.593 9.238 6.89 20.025 6.89 32.359 0 12.283-2.297 23.018-6.89 32.205-4.593 9.186-11.044 16.334-19.354 21.444-8.309 5.109-18.037 7.664-29.185 7.664Zm.077-19.431c7.226 0 13.213-1.91 17.961-5.729 4.748-3.819 8.257-8.903 10.528-15.251 2.323-6.348 3.484-13.341 3.484-20.979 0-7.587-1.161-14.554-3.484-20.902-2.271-6.4-5.78-11.535-10.528-15.406-4.748-3.87-10.735-5.806-17.961-5.806-7.277 0-13.315 1.936-18.115 5.806-4.748 3.871-8.283 9.006-10.605 15.406-2.271 6.348-3.407 13.315-3.407 20.902 0 7.638 1.136 14.631 3.407 20.979 2.322 6.348 5.857 11.432 10.605 15.251 4.8 3.819 10.838 5.729 18.115 5.729Zm81.189 61.622v-163.5h22.605v19.276h1.936c1.342-2.477 3.277-5.341 5.806-8.593 2.529-3.251 6.038-6.09 10.528-8.516 4.49-2.477 10.425-3.715 17.806-3.715 9.599 0 18.166 2.425 25.701 7.277 7.535 4.851 13.445 11.844 17.728 20.979 4.335 9.135 6.503 20.128 6.503 32.979 0 12.851-2.142 23.869-6.425 33.056-4.284 9.135-10.167 16.179-17.651 21.134-7.483 4.903-16.025 7.354-25.624 7.354-7.226 0-13.135-1.212-17.728-3.638-4.542-2.426-8.103-5.264-10.683-8.516-2.581-3.251-4.568-6.141-5.961-8.67h-1.394v63.093h-23.147Zm22.683-104.046c0 8.361 1.213 15.69 3.638 21.986 2.426 6.297 5.935 11.225 10.529 14.786 4.593 3.51 10.218 5.265 16.876 5.265 6.916 0 12.696-1.832 17.341-5.497 4.645-3.716 8.154-8.748 10.528-15.096 2.426-6.348 3.639-13.496 3.639-21.444 0-7.844-1.187-14.889-3.561-21.134-2.323-6.245-5.832-11.173-10.529-14.786-4.645-3.613-10.451-5.419-17.418-5.419-6.709 0-12.386 1.729-17.031 5.187-4.593 3.458-8.077 8.283-10.451 14.476-2.374 6.193-3.561 13.419-3.561 21.676Zm200.968-30.424-20.979 3.716c-.877-2.683-2.271-5.238-4.18-7.664-1.858-2.425-4.387-4.412-7.587-5.961-3.2-1.548-7.2-2.322-11.999-2.322-6.555 0-12.025 1.471-16.412 4.413-4.387 2.89-6.58 6.631-6.58 11.225 0 3.974 1.47 7.173 4.412 9.599s7.69 4.413 14.244 5.961l18.89 4.335c10.941 2.529 19.095 6.426 24.463 11.69 5.367 5.264 8.051 12.102 8.051 20.515 0 7.122-2.064 13.47-6.193 19.044-4.077 5.522-9.78 9.857-17.109 13.006-7.277 3.148-15.715 4.722-25.315 4.722-13.315 0-24.179-2.839-32.591-8.516-8.413-5.728-13.574-13.857-15.483-24.385l22.373-3.407c1.393 5.832 4.258 10.245 8.593 13.238 4.335 2.942 9.986 4.413 16.954 4.413 7.586 0 13.65-1.574 18.192-4.722 4.542-3.2 6.813-7.097 6.813-11.69 0-3.716-1.394-6.838-4.181-9.367-2.735-2.529-6.941-4.439-12.618-5.729l-20.128-4.413c-11.096-2.528-19.302-6.554-24.618-12.076-5.264-5.523-7.896-12.516-7.896-20.98 0-7.019 1.961-13.16 5.883-18.424 3.922-5.265 9.341-9.368 16.257-12.31 6.916-2.993 14.838-4.49 23.766-4.49 12.851 0 22.967 2.787 30.347 8.361 7.38 5.523 12.257 12.929 14.631 22.218Zm56.958-68.666-2.012 112.948h-21.444l-2.013-112.948h25.469ZM600.898 212.47c-4.283 0-7.948-1.497-10.993-4.49-3.045-3.045-4.541-6.709-4.49-10.993-.051-4.232 1.445-7.845 4.49-10.838 3.045-3.045 6.71-4.568 10.993-4.568 4.181 0 7.793 1.523 10.838 4.568 3.045 2.993 4.594 6.606 4.645 10.838-.051 2.838-.8 5.445-2.245 7.819a16.012 16.012 0 0 1-5.574 5.574c-2.322 1.393-4.877 2.09-7.664 2.09Z"
        fill="var(--art-accent, #1B66D6)"
      />
    </svg>
  );
};

export default Oops;
